import React, {Component} from 'react';
import "./App.css";



class Geschichte extends Component {


	UNSAFE_componentWillMount(){
		window.scrollTo(0,0);
	}

render() {	
  return (	

	<div className="homeApp">
	<div className="contentHome">	

	<h2>Was für die gute Laune<br/>und eine Hommage<br/>an die Künstler die sich trauen</h2>
	  
		
		<div className="Ein"  >
			<a className="videoText" rel="noopener"  href="https://wirtube.de/w/bEH7ozBgLajDEKccoQgfvy" target="_blank" >
			#629- Islamist tötet Deutschen! #Biden droht die Welt zu sprengen!? 03.12.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Zk08vt_Lx6M" target="_blank" >
			MARKUS LANZ – Vielfliegerin wird von allen AUSGELACHT! 04.06.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Zk08vt_Lx6M" target="_blank" >
				Ex-Küchenhilfe dreht nationalistisch AB! 28.02.2023
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=Zk08vt_Lx6M" target="_blank" >
			Das Fest der Lippe… Liebe… Endlich, die genderneutrale Weihnachtsgeschichte ist da. 25.12.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=RckgdgOBv2M" target="_blank" >
			BAUTZENER CDU-Landrat schießt scharf gegen FLÜCHTLINGE! 22.12.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=7wrijIeVjSA" target="_blank" >
				Entschuldigung… ich habe mitgelacht! 04.12.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=nhDcz70jitY" target="_blank" >
			MAISCHBERGER – CSU-Rüpel rupft KLIMA-KÜKEN! 17.11.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=XYFhyR_BMSk" target="_blank" >
			Meine lieben Freunde der heiteren Satire 13.11.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=FCNQ-JPdBF8" target="_blank" >
			Tim Kellner - BAERBOCK bläfft bei UN-Rede: „Ich bin nicht NAIV!“ ᴴᴰ 03.08.2022
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=02pCaBA05IU" target="_blank" >
			Lisa Fitz - Verlass auf Amazon 05.04.2022
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=ucrAV0SeLu0" target="_blank" >
				Lisa Fitz - Die heiße Nadel
			</a>
			<a className="videoText"  rel="noopener" href="https://wirtube.de/w/h1vJ6mbDEeSLWPbGNtZ179" target="_blank" >
				Freiheit für immer verschoben!!!
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=4lBQhpbNamw" target="_blank" >
				Rima-Spalter mit Marco Rima: Erklär-Bär
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=WkfQfxp82rQ" target="_blank" >
			Ludger K.: Lauterbach warnt! Aber wer warnt vor Lauterbach?
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=U5x4ZbdtoH0" target="_blank" >
				2G auf unserer Tournee? Die Abstimmung! Die Echse und der runde Tisch
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=f3SvO5QIFCM" target="_blank" >
				Strauß zerlegt Söder!
			</a>		
			<a className="videoText"  rel="noopener" href="https://www.frei3.de/article/b1ade8db-f71e-4ebf-9ca4-0ffc0b341100" target="_blank" >
				Selbst das spanische Fernsehen lacht uns aus!
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=M8cBaXL3QOI" target="_blank" >
				Die Echse spielt Coronakrise nach
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=JSZP8REJhXs" target="_blank" >
				"COVIDIOTEN" Psychologie der Massen
			</a>
			<a className="videoText" rel="noopener"  href="https://www.youtube.com/watch?v=BKWceSwhQvI"  target="_blank">
			  Valentinstag! Liebe für ALLE❤❤❤<br/>!!! SATIRE!!!  14.02.2021
			</a>							
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=AJ094h6yTBA" target="_blank" >
				Horscht rufft beim MP an
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=et2FcEM6PoA&t=2s" target="_blank" >
				Lutz Männel	"De gefährlichen Münzen" 16.12.2020
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=gTPK8NDDVME&feature=emb_title" target="_blank" >
				Die fiktive Angst - Volker Pispers 2007
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=zhnhJJEZqnU" target="_blank" >
				Uwe Steimle 02.06.2020
			</a>	
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=WAP7_-s-4j8" target="_blank" >
				Angela erklärt den Corona R-Wert
			</a>	
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=BNCJsfbr_lc" target="_blank" >
				Monika Gruber 05.11.2020
			</a>					
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=o_wei7eIFWE" target="_blank" >
				Lisa Fitz 06.11.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=Vh6FQiKX1tU" target="_blank" >
				Robert Matuschewski 29.11.2020
			</a>				
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=D75goRwZ7x4" target="_blank" >
				Möhre über "Lockdown light"
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=gLtXT7jAhk4&t=5s" target="_blank" >
				Simone Solga 30.10.2020
			</a>												
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=JjNMZW91E1g" target="_blank" >
				Lutz Männel	23.09.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=JxY0dsQQN3w" target="_blank" >
				Reim Patrouille corona
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=3VxGQE_dXtc" target="_blank" >
				Tavernenlied
			</a>

			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=W4SxsJv48sY" target="_blank" >
				Probleme einer Quarantäne
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=iZMssbs_elo" target="_blank" >
				Maria Mucha + Reinwald Kranner
			</a>		
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=r_Yk7F6Wx9c&feature=youtu.be" target="_blank" >
			Bill Gates Is a Wanker
			</a>				
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=YIWj1LdRJM8" target="_blank" >
				BERSERK NETWORKS
			</a>	
							
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=dR-GAC3SH0Q" target="_blank" >
				Petutschnig Hons aus Schlatzing
			</a>											
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=k4OFXkcn24Q" target="_blank" >
				Corona Song von Dieter Hallervorden
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=o4eoBQdGYws" target="_blank" >
				Monika Gruber
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=GH32J6aZaZ0" target="_blank" >
				Gerald Grosz	17.10.2020
			</a>			
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=5ahXjGq2nv0" target="_blank" >
				Gerald Grosz	23.09.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=vbCSUEXw_Qo" target="_blank" >
				Gerald Grosz	15.09.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=p6o3SyWRqqU&t=139s" target="_blank" >
				Gerald Grosz	26.09.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.frei3.de/article/e74c02a1-fc57-4fdf-a292-91642a259a0c" target="_blank" >
				Lisa Fitz 18.09.2020 - Bananenrepublik
			</a>
			<a className="videoText"  rel="noopener" href="https://www.frei3.de/article/a4f75882-17d4-432d-a8d3-51c42db0443b" target="_blank" >
				Die sieben Todsünden - Andreas Rebers 26.09.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=Xhg35cecLxA" target="_blank" >
				Lutz Männel	28.07.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=F0i1TNrAq6E" target="_blank" >
				Lutz Männel	10.07.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=cIEi4v2SnTw" target="_blank" >
				Lutz Männel	03.06.2020
			</a>
			<a className="videoText"  rel="noopener" href="https://www.youtube.com/watch?v=keFTrAOm71Q" target="_blank" >
				Lutz Männel	"Nu is Schluss" 23.12.2020
			</a>
			

		</div>

</div>


	

</div>
	
	 
  );
};
};

export default Geschichte;
